import { reactive, ref, watch, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import { addDomain, editDomain } from '@/api/payManage/domian';
export default /*#__PURE__*/_defineComponent({
  __name: 'FormModal',
  props: {
    modelVisible: {
      default: false,
      type: Boolean
    },
    columnItem: {
      default: () => ({}),
      type: Object
    },
    tabKey: {
      default: '3',
      type: String
    },
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  emits: ['update:modelVisible'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const formData = reactive({
      accountName: '',
      domainGroup: '',
      marketType: '',
      developerUrl: '',
      inlandCallbackUrl: '',
      overseasCallbackUrl: ''
    });
    const formRef = ref();
    const isLoading = ref(0);
    const marketTypeMap = {
      3: 'GP',
      2: 'IOS',
      1: '安卓/小游戏'
    };
    const closeModal = () => {
      emit('update:modelVisible', false);
      formRef.value.resetFields();
    };
    const handleOk = async () => {
      let {
        id
      } = props.columnItem;
      let params = {
        id,
        marketType: Number(props.tabKey)
      };
      formRef.value.validate().then(async res => {
        if (res) {
          let {
            overseasCallbackUrl,
            inlandCallbackUrl,
            domainGroup
          } = res;
          params = Object.assign(params, {
            overseasCallbackUrl,
            inlandCallbackUrl
          });
          if (props.isAdd) {
            params = Object.assign(params, {
              domainGroup
            });
            delete params.id;
          }
          try {
            var _props$columnItem;
            const res = (_props$columnItem = props.columnItem) !== null && _props$columnItem !== void 0 && _props$columnItem.id ? await editDomain(params) : await addDomain(params);
            if (res.code === '0') {
              message.success(res.msg);
              emit('refresh');
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '域名管理编辑',
                  element_name: '保存'
                }
              });
              closeModal();
            } else {
              message.error(res.msg);
            }
          } catch (e) {}
        }
      });
    };
    watch(() => props.columnItem, newVal => {
      if (newVal) {
        Object.assign(formData, {
          ...newVal,
          marketType: marketTypeMap[props.tabKey],
          inlandCallbackUrl: newVal.inlandCallbackUrl || 'https://',
          overseasCallbackUrl: newVal.overseasCallbackUrl || 'https://'
        });
        if (props.isAdd) {
          formData.domainGroup = '';
        }
      }
    });
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: props.isAdd ? '新增' : '编辑',
        open: __props.modelVisible,
        onOk: handleOk,
        onCancel: closeModal,
        destroyOnClose: true,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: formData,
          "label-col": {
            span: 6
          },
          "wrapper-col": {
            span: 15
          },
          style: {
            "margin-top": "25px"
          },
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [props.tabKey != '1' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "账号简称：",
            name: "accountName"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.accountName,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.accountName = $event),
              disabled: true
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: "域名组：",
            name: "domainGroup"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.domainGroup,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.domainGroup = $event),
              autocomplete: "off",
              placeholder: "请输入域名组",
              disabled: props.isAdd ? false : true
            }, null, 8, ["value", "disabled"])]),
            _: 1
          }), props.tabKey != '1' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: "市场类型：",
            name: "marketType"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.marketType,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.marketType = $event),
              disabled: true
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), props.tabKey != '1' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            label: "开发者网址：",
            name: "developerUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: formData.developerUrl,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.developerUrl = $event),
              "auto-size": "",
              disabled: true
            }, null, 8, ["value"])]),
            _: 1
          })) : _createCommentVNode("", true), props.tabKey != '3' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 3,
            label: props.tabKey == '1' ? '国内支付域名' : '国内域名',
            name: "inlandCallbackUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.inlandCallbackUrl,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.inlandCallbackUrl = $event),
              autocomplete: "off"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: props.tabKey == '1' ? '国外支付域名' : '海外域名',
            name: "overseasCallbackUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.overseasCallbackUrl,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.overseasCallbackUrl = $event),
              autocomplete: "off"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "open"]);
    };
  }
});